module.exports = __webpack_public_path__ + "img/CH01-008-009.4b608f84.jpg";